module.exports = __webpack_public_path__ + "fonts/SourceHanSansCN-Regular.11c302dd.otf";